module.exports = __webpack_public_path__ + "img/products-campers.ecb40d5e.jpeg";